export default {
    // serverUrl: 'http://localhost:4000'
    serverUrl: 'https://rest.connect-api.com'
};
